import { router } from 'expo-router';
import { useState } from 'react';
import {
    BodyMediumEmphasized,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    CheckIcon,
    H2Emphasized,
    Icon,
    isNonMobileWeb,
    ScreenContainer,
    View,
    YStack,
} from 'smoothie';

import {
    centsToFormattedDollars,
    getLastFourAccountNumber,
} from '../../../common/utils/bankingUtils';
import { AMBIGUOUS_DATE_FORMAT, format } from '../../../common/utils/dateUtils';

interface CheckDepositSuccessProps {
    amountCents: number;
    accountNumberMasked: string;
}

const CheckDepositSuccess = ({
    amountCents,
    accountNumberMasked,
}: CheckDepositSuccessProps) => {
    const [depositDate] = useState(() =>
        format(new Date(), AMBIGUOUS_DATE_FORMAT),
    );
    const accountLastFour = getLastFourAccountNumber(accountNumberMasked);

    return (
        <ScreenContainer
            hasCloseButton
            onClose={() => {
                router.navigate('/home/banking');
            }}
            containerProps={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: isNonMobileWeb ? 'flex-start' : 'space-between',
            }}
        >
            <YStack
                justifyContent={isNonMobileWeb ? 'flex-start' : 'space-between'}
                width="100%"
                minHeight="100%"
                alignSelf="center"
            >
                <YStack
                    alignItems="center"
                    marginTop={isNonMobileWeb ? 50 : 48}
                    marginBottom={isNonMobileWeb ? 100 : 0}
                    paddingHorizontal={24}
                >
                    <View
                        alignSelf="center"
                        padding={25}
                        borderRadius={20}
                        backgroundColor="$green1000"
                        marginTop={30}
                        marginBottom={30}
                    >
                        <Icon icon={CheckIcon} color="$white" size={30} />
                    </View>
                    <H2Emphasized textAlign="center">
                        Deposit submitted!
                    </H2Emphasized>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={8}
                        marginHorizontal={12}
                    >
                        Your {centsToFormattedDollars(amountCents)} check
                        deposit to account *{accountLastFour} has been submitted
                        and is being processed.
                    </BodyMediumRegular>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={16}
                        marginHorizontal={12}
                    >
                        To allow time for the check to be processed and
                        collected, the full deposit amount will be made
                        available no later than 5 business days after{' '}
                        {depositDate}.
                    </BodyMediumRegular>
                    <BodyMediumEmphasized
                        textAlign="center"
                        marginTop={24}
                        marginHorizontal={12}
                    >
                        What to do with your check:
                    </BodyMediumEmphasized>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={8}
                        marginHorizontal={12}
                    >
                        Once funds have successfully posted, write
                        &quot;VOID&quot; and the date of deposit on the front of
                        your check.
                    </BodyMediumRegular>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={8}
                        marginHorizontal={12}
                    >
                        Store in a safe place for 60 days, and then destroy it.
                    </BodyMediumRegular>
                </YStack>

                <View
                    paddingHorizontal={isNonMobileWeb ? 24 : 0}
                    marginTop={24}
                >
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Done"
                        onPress={() => {
                            router.navigate('/home/banking');
                        }}
                    />
                </View>
            </YStack>
        </ScreenContainer>
    );
};

export default CheckDepositSuccess;
